import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

// noinspection JSUnusedLocalSymbols
export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#C2C2C2',
    color: '#474747',
    padding: '10px 12px',
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  cursor: 'pointer',
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide the last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const useStyles = (isMobile) => ({
  tableContainer: {
    flex: 1,
    width: '100%',
    minWidth: '700px',
    overflow: 'auto',
    minHeight: '60vh',
    paddingBottom: '320px', // space for pagination + FAB
    // '::-webkit-scrollbar': {
    //   display: 'none',
    // },
  },
  pagination: {
    display: 'flex',
    justifyContent: isMobile ? 'center' : 'flex-end',
    padding: '12px 16px',
    position: 'fixed',
    bottom: isMobile ? '50px' : '42px',
    left: 0,
    right: 0,
    width: '100%',
    backgroundColor: '#fff',
    zIndex: 1000,
    borderTop: '1px solid #e0e0e0',
    boxShadow: '0 -2px 4px rgba(0,0,0,0.1)',
  },
});

export default useStyles;
